export const BRUSSELS_TIMEZONE = "Europe/Brussels" as const;
